import { clearStorage } from '@forvalter/utils/storage';
import { toPascalCase } from '@forvalter/utils/TypeScriptUtils';

export const filterStateKeys = [
    'userAdministrationTableFilters',
    'prosjektAvfallTableFilters',
] as const;

export type FilterStateKey = (typeof filterStateKeys)[number];

type ExtractTableKey<T> = T extends `${infer K}TableFilters` ? K : never;

export type FilterTableKey = ExtractTableKey<FilterStateKey>;

type FilterTableConfig = {
    [K in FilterTableKey]: {
        stateKey: `${K}TableFilters`;
        storageKey: `stored${Capitalize<K>}TableFilters`;
        actionPrefix: K;
    };
};

export const filterTableConfig = Object.fromEntries(
    filterStateKeys.map((stateKey) => {
        const tableKey = stateKey.replace('TableFilters', '') as FilterTableKey;
        const pascalKey = toPascalCase(tableKey);
        return [
            tableKey,
            {
                stateKey,
                storageKey: `stored${pascalKey}TableFilters`,
                actionPrefix: tableKey,
            },
        ];
    }),
) as FilterTableConfig;

export function clearAllFilterStorage() {
    Object.values(filterTableConfig).forEach(({ storageKey }) => {
        clearStorage(storageKey);
    });
}

export function clearFilterStorageFor(key: FilterTableKey) {
    const config = filterTableConfig[key];
    clearStorage(config.storageKey);
}
